import { useRef } from 'react';
import { useWordReveal } from '../lib/motion';

/** Text that appears word by word whenever it changes (static with reduced motion). */
export function RevealText({ text, className }: { text: string; className?: string }) {
  const ref = useRef<HTMLParagraphElement>(null);
  useWordReveal(ref, text);
  return (
    <p ref={ref} className={className}>
      {text.split(/(\s+)/).map((part, i) =>
        /^\s+$/.test(part) ? (
          part
        ) : (
          <span key={i} className="fx-word">
            {part}
          </span>
        ),
      )}
    </p>
  );
}
